var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonalcard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5833 19.25H6.41659C2.74992 19.25 1.83325 18.3333 1.83325 14.6667V7.33333C1.83325 3.66667 2.74992 2.75 6.41659 2.75H15.5833C19.2499 2.75 20.1666 3.66667 20.1666 7.33333V14.6667C20.1666 18.3333 19.2499 19.25 15.5833 19.25Z",
    stroke: "#292D32",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8333 7.33337H17.4166",
    stroke: "#292D32",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 11H17.4167",
    stroke: "#292D32",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5833 14.6666H17.4166",
    stroke: "#292D32",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.79173 10.3492C8.70807 10.3492 9.4509 9.60638 9.4509 8.69005C9.4509 7.77372 8.70807 7.03088 7.79173 7.03088C6.8754 7.03088 6.13257 7.77372 6.13257 8.69005C6.13257 9.60638 6.8754 10.3492 7.79173 10.3492Z",
    stroke: "#292D32",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9999 14.9691C10.8716 13.6399 9.81742 12.5949 8.48825 12.4758C8.02992 12.4299 7.56242 12.4299 7.09492 12.4758C5.76575 12.6041 4.71159 13.6399 4.58325 14.9691",
    stroke: "#292D32",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalcard);
export default __webpack_public_path__ + "static/media/personalcard.90ea2cf0bb63b0859fc82f0ee683f90d.svg";
export { ForwardRef as ReactComponent };